
const mutations = {
  changePhone(state, val) {
    state.phone = val
  },
  changeGameStatus(state, val) {
    state.gameStatus = val
  },
  changeTel(state, val) {
    state.tel = val
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/mutations.js